export default {
  path: '',
  component: {
    template: '<router-view :key="$route.fullPath" />'
  },
  meta: {
    title: '订单管理',
    navbar: 'el-icon-document'
  },
  children: [
    ...require('./orders/route').default,
    ...require('./logistics/route').default,
    ...require('./after-sales/route').default,
    ...require('./order-commissions/route').default,
    ...require('./commission-settlement-applications/route').default,
  ]
}
